module.exports = __webpack_public_path__ + "static/img/04.f0cbe85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/_20241216_2/04.png
// module id = sM5l
// module chunks = 0